export const DEFAULT_COLORS = [
  { value: '#CF1322', label: 'Red' },
  { value: '#D48806', label: 'Orange' },
  { value: '#D4B106', label: 'Yellow', additional: 'gold' },
  { value: '#389E0D', label: 'Green' },
  { value: '#08979C', label: 'Cyan' },
  { value: '#096DD9', label: 'Blue' },
  { value: '#531DAB', label: 'Purple' },
  { value: '#C41D7F', label: 'Magenta' },
  { value: '#141414', label: 'Black' },
  { value: '#8C8C8C', label: 'Gray' },
]

export const registerComponentProperty = <T extends Function, O extends object>(
  component: T,
  originComponent: object
) => {
  for (let i in originComponent) {
    if (!component.hasOwnProperty(i) && i !== 'defaultProps') {
      component[i] = originComponent[i]
    }
  }
  return component as T & O
}

export const getColor = value => {
  let cur: any = null
  if (value && typeof value === 'string') {
    cur = DEFAULT_COLORS.find(item => item.value.toLowerCase() === value.toLowerCase())
  }
  return (cur?.additional || cur?.label || '').toLowerCase()
}